import { useI18n } from 'vue-i18n';

export const useSportLiveTvTranslation = () => {
  const { t, locale } = useI18n();

  const translate = (key, params) => t(`sportLiveTvPage.${key}`, params ?? {});

  return { t: translate, locale };
};
